import { useState, useEffect } from 'react';
import { getCompanyLogoUrl } from '@/utils/companyLogo';

/**
 * Hook que obtiene la URL del logo de la empresa desde site_sections (hero.logo).
 * Se actualiza automáticamente si el logo cambia en la base de datos.
 */
export function useCompanyLogo(): string {
  const [logoUrl, setLogoUrl] = useState<string>('');

  useEffect(() => {
    let mounted = true;

    getCompanyLogoUrl().then((url) => {
      if (mounted) setLogoUrl(url);
    }).catch(() => {
      // fallback silencioso — la utilidad ya maneja el default
    });

    return () => { mounted = false; };
  }, []);

  return logoUrl;
}